export const getFileDownloadUrl = (bucketName: string, blobName: string): string => {
  const baseUrl =
    process.env.NODE_ENV === "production"
      ? "https://storage.googleapis.com"
      : "https://storage.googleapis.com";

  return `${baseUrl}/${bucketName}/${blobName}`;
};

export const isImageMimeType = (mimeType: string): boolean => {
  return mimeType.startsWith("image/");
};

export const formatFileSize = (bytes: number): string => {
  const units = ["B", "KB", "MB", "GB"];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  return `${size.toFixed(2)} ${units[unitIndex]}`;
};
